/**
 * Junta las líneas «- …» seguidas en una lista de viñetas. Lo usan los textos
 * escritos como lista de párrafos (ayuda, privacidad), que así no llevan HTML.
 */
export function agrupar(parrafos: string[]): (string | string[])[] {
  const out: (string | string[])[] = [];
  parrafos.forEach(t => {
    if (t.startsWith('- ')) {
      const ultimo = out[out.length - 1];
      if (Array.isArray(ultimo)) ultimo.push(t.slice(2)); else out.push([t.slice(2)]);
    } else out.push(t);
  });
  return out;
}
